import { __decorate } from "tslib";
import { SerializableObject } from '@openhps/core';
import { activitystreams } from '../../terms';
import { Activity } from './Activity';
let ActivityRemove = class ActivityRemove extends Activity {
};
ActivityRemove = __decorate([
    SerializableObject({
        rdf: {
            type: activitystreams.Remove,
        },
    })
], ActivityRemove);
export { ActivityRemove };
//# sourceMappingURL=ActivityRemove.js.map